import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';

export default class DropDownInput extends React.Component {

    render() {

        let divClassName = '';
        let iconClassName = '';
        let helpBlock = '';

        if (this.props.validation) {
            if (this.props.validation.get('validationState') === 'error') {
                divClassName = 'form-group has-feedback has-error';
                iconClassName = 'form-control-feedback glyphicon glyphicon-remove';
                helpBlock = this.props.validation.get('helpBlock');
            }
        }

        let showRequired = null;
        if (this.props.required) {
            showRequired = (<span className="text-danger" style={{ marginLeft: 5 }}>*</span>)
        }

        return (
            <div className={divClassName}>
                <label className="control-label">{this.props.label}{showRequired}</label>
                <Typeahead
                    onChange={(event) => {
                        if (event[0]) {
                            this.props.onChange(this.props.id, event[0].value, event[0].label);
                        }
                    }}
                    options={this.props.options}
                    selected={this.props.selected}
                />
                <span className={iconClassName} />
                <span className="help-block">{helpBlock}</span>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/common/DropDownInput.jsx